// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  domain: 'TYM',
  paginator: {
    pageSizeOption: [5, 10, 25, 100],
    pageSize: 10
  },
  mimeTypes: {
    excel: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    pdf: 'application/pdf',
    binary: 'application/octet-stream',
    csv: 'text/csv',
  },
  dialogSizes: {
    wide: '750px',
    narrow: '300px',
    fullScreen: '100vw',
  }
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
